import React, { useEffect, useState } from 'react';
import {Link} from 'react-router-dom';
import {history} from '../misc/history';
import penyelenggara from '../assets/penyelenggara-sertifikat-elektronik.png';
import leftArrow from '../assets/left-arrow.svg';

export default () => {
  const [isLogin, setIsLogin] = useState(false);

  useEffect(() => {
    if (localStorage.getItem('kominfo-psre')) setIsLogin(true)
  })

  const handleLogOut = () => {
    localStorage.removeItem('kominfo-psre');
    setIsLogin(false)
  }

  return (
    <nav className="swipe-nav" id="nav" data-swipe-drawer="" data-swipe-open-class="swipe-nav--open"><Link className="swipe-nav__overlay" to="#0" role="button" aria-label="Close Navigation" tabIndex="-1" data-swipe-overlay="">&nbsp;</Link>
    <div className="swipe-nav__panel" data-swipe-panel="">
      <div className="swipe-nav__scroller">
        <div className="swipe-nav__inner">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item"><Link className="nav-link" to="/">Beranda</Link></li>
            {isLogin ? <li className="nav-item"><Link className="nav-link" to="/profiles">Akun Saya</Link></li> : <li className="nav-item"><Link className="nav-link" to="/login">Masuk</Link></li>}
            <li className="nav-item"><Link className="nav-link" to="/listPSrE/_">Perusahaan Penyelenggara (PSrE)</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/forum">Forum</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/event/infographic">Infografik</Link></li>
            <div style={{position: 'absolute', bottom: '30px',width: '75%'}}>
              {isLogin ? <li className="nav-item text-center d-lg-none d-md-block d-sm-block d-block" onClick={() => handleLogOut()}>Logout</li> : <Link to='/login'><li className="nav-item text-center d-lg-none d-md-block d-sm-block d-block" onClick={() => handleLogOut()}>Login</li></Link>}
              <li className="nav-item d-lg-none d-md-block d-sm-block d-block"><Link className="btn-blue btn w-100 ind" to="/verifyPDF">Verifikasi PDF</Link></li><img className="mx-auto d-lg-block d-md-none d-sm-none d-none" src={penyelenggara} alt="penyelenggara-sertifikat-elektronik" height="50" />
            </div>
          </ul><Link className="menu-button-close" to="#0" role="button" aria-label="Close Navigation" data-swipe-close=""><img src={leftArrow} alt="left-arrow" style={{width: '18px', height:'18px'}} /></Link>
          <p className="menu-text">Menu</p>
        </div>
      </div>
    </div>
  </nav>
  )
}
